import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {ListViewComponent} from '../components/list-view/list-view.component';
import { ListValueBooleanComponent } from '../components/list-value-boolean/list-value-boolean.component';
import {ImportantItemFilterDirective} from '../directives/list-view/important-item-filter.directive';
import {ItemFilterDirective} from '../directives/list-view/item-filter.directive';
import {ListActionsDirective} from '../directives/list-view/list-actions.directive';
import { ListBannerDirective } from '../directives/list-view/list-banner.directive';
import {ListAdditionalContentDirective} from '../directives/list-view/list-additional-content-directive';
import {ListItemDirective} from '../directives/list-view/list-item-directive';
import {ListItemExpandDirective} from '../directives/list-view/list-item-expand.directive';
import {CustomContentDirective} from '../directives/list-view/custom-content-directive';
import {PagerModule} from './pager.module';
import {MemoViewComponent} from "../components/memo-view/memo-view.component";
import { ListViewFacetsComponent } from '../components/list-view-facets/list-view-facets.component';
import { PipesModule } from './pipes.module';

@NgModule({
  declarations: [
    ListViewComponent,
    ListViewFacetsComponent,
    ListValueBooleanComponent, 
    ImportantItemFilterDirective,
    ItemFilterDirective,
    ListActionsDirective,
    ListBannerDirective,
    ListAdditionalContentDirective,
    ListItemDirective,
    ListItemExpandDirective,
    MemoViewComponent,
    CustomContentDirective
  ],
  imports: [
    CommonModule,
    PagerModule,
    FormsModule,
    PipesModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    ListViewComponent,
    ListViewFacetsComponent,
    ListValueBooleanComponent,
    ImportantItemFilterDirective,
    ItemFilterDirective,
    ListActionsDirective,
    ListBannerDirective,
    ListAdditionalContentDirective,
    ListItemDirective,
    ListItemExpandDirective,
    MemoViewComponent,
    CustomContentDirective
  ],
  providers: [],
})
export class ListViewModule {
}
